var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaybill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(-3575 -7467)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(3575 7467)",
    fill: "#192754"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_History_3324311",
    transform: "matrix(1, 0.017, -0.017, 1, 3578.135, 7442.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(7.36 34.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M20.36,16.434a3.654,3.654,0,0,1,.594.051V8.3A1.842,1.842,0,0,0,19.115,6.46H9.2A1.842,1.842,0,0,0,7.36,8.3V19A1.842,1.842,0,0,0,9.2,20.841h7.659a3.586,3.586,0,0,1,3.5-4.407ZM10.034,8.813h8.243a.476.476,0,1,1,0,.953H10.034a.476.476,0,0,1,0-.953Zm0,2.909h8.243a.476.476,0,1,1,0,.953H10.034a.476.476,0,1,1,0-.953Zm0,2.905h8.243a.476.476,0,1,1,0,.953H10.034a.476.476,0,0,1,0-.953Zm5.935,3.861H10.034a.476.476,0,1,1,0-.953h5.935a.476.476,0,1,1,0,.953Zm4.392-1.1a2.647,2.647,0,1,0,2.648,2.645A2.647,2.647,0,0,0,20.36,17.386Zm1.264,3.121H20.36a.476.476,0,0,1-.476-.476V18.58a.476.476,0,1,1,.953,0v.975h.787a.476.476,0,0,1,0,.953Z",
    transform: "translate(-7.36 -6.46)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaybill);
export default __webpack_public_path__ + "static/media/Waybill.926b3e0d.svg";
export { ForwardRef as ReactComponent };